/* global module require */

// Load 3rd party polyfills. babel-polyfill is loaded by config.
require('classlist-polyfill');

// Load polyfill for setImmediate.
if (!window.setImmediate) {
    require('setimmediate');
}

// Overwrite CSCart's awful development js error handler that forwards you to an empty
// page with just the error message, completely devoid of context, line numbers, call stacks,
// and makes it impossible to troubleshoot on page.
window.onerror = null;

const lib = {
    address_book: require('../tv_address_book/address_book.ts'),
    artwork: require('../tv_artwork/tv_artwork.ts'),
    cart: null,
    configurator: null,
    configurator_v2: null,
    credit_application: require('../tv_credit_application/credit_application.ts'),
    customer_chat_log: require('../tv_utils/customer_chat_log.ts'),
    customer_orders: require('../tv_customer_orders/customer_orders.ts'),
    customer_records: require('../tv_customer_records/customer_records.ts'),
    designtool: null,
    email_validation: require('../tv_address_book/email_validation.ts'),
    freshchat_facade: require('../tv_third_party_integrations/freshdesk-messaging-facade.js'),
    g_recaptcha: require('../tv_third_party_integrations/g_recaptcha.ts'),
    init_photoswipe: require('./vendor/photoswipe/init_photoswipe.ts'),
    logrocket: require('./logrocket.ts'),
    employment_application: require('../tv_employment_application/tv_employment_application.js'),
    newsletters: require('../tv_newsletters/newsletters.ts'),
    payments: require('../tv_payments/payments.ts'),
    products: null,
    product_quotes: null,
    product_videos: null,
    search: require('../tv_search/search.ts'),
    shipping: null,
    site_wide_banner: require('../tv_site_wide_banner/site_wide_banner.ts'),
    faq_schema: require('../tv_faq_schema/faq_schema.ts'),
    order_progress_bars: require('../tv_order_progress_bars/order_progress_bars.ts'),
    users: require('../tv_users/users.ts'),
    ajax_toggle: require('../tv_utils/ajax_toggle.ts'),
    search_bar: require('../tv_utils/search_bar.ts'),
    tv_modal: require('../tv_utils/tv_modal.ts'),
    modal_closer: require('../tv_utils/modal_closer.ts'),
    sign_in: require('../tv_utils/sign_in.ts'),
    site_navigation: require('../tv_utils/site_navigation.ts'),
    sticky_block: require('../tv_utils/sticky_block.ts'),
    password_view: require('../tv_utils/password_view.ts'),
    yotpo: require('../tv_third_party_integrations/yotpo.ts'),
    faq_section: require('../tv_utils/faq_section.ts')
};

module.exports = lib;
